import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
import { createBasePlugin } from 'wix-rich-content-plugin-commons';
import { AtomicBlockUtils, Modifier, EditorState, SelectionState } from '@wix/draft-js';
import { DND_UPLOAD_TYPE } from './types';
import { getDefaultComponentData } from '../plugin-image/types';
import UploadThumb from './components/UploadThumb';
// Given an uploadId, append an UploadThumb to the editor state, which will display while the asset loads.
function attachUploadBlock(editorState, uploadId) {
    // Create the entity
    let contentState = editorState.getCurrentContent();
    contentState = contentState.createEntity(DND_UPLOAD_TYPE, 'IMMUTABLE', {
        config: {
            alignment: 'center',
            size: 'content'
        },
        uploadId
    });
    const entityKey = contentState.getLastCreatedEntityKey();
    // Insert a new block
    const newEditorState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
    const recentlyCreatedKey = newEditorState.getSelection().getAnchorKey();
    const newBlock = newEditorState.getCurrentContent().getBlockBefore(recentlyCreatedKey);
    return {
        editorState: newEditorState,
        blockKey: newBlock && newBlock.getKey()
    };
}
// Replace the previously added UploadThumb with an image referencing an actual PapiDeviation
function attachDeviationBlock(editorState, deviation, uploadThumbBlockKey) {
    let contentState = editorState.getCurrentContent();
    // Select the upload thumb to be replaced with an an image entity.
    // If nextKey is falsy it means that the upload thumb has been deleted, in which case we abort.
    const nextKey = contentState.getKeyAfter(uploadThumbBlockKey);
    if (!nextKey) {
        return;
    }
    const replaceSelection = new SelectionState({
        anchorKey: uploadThumbBlockKey,
        anchorOffset: 0,
        focusKey: nextKey,
        focusOffset: 0
    });
    // Insert new deviation entity
    contentState = contentState.createEntity('wix-draft-plugin-image', 'IMMUTABLE', _object_spread_props(_object_spread({}, getDefaultComponentData()), {
        data: deviation
    }));
    const entityKey = contentState.getLastCreatedEntityKey();
    // Replace thumb entity
    return EditorState.push(editorState, Modifier.applyEntity(contentState, replaceSelection, entityKey), 'apply-entity');
}
function dndUploadPluginCreator() {
    let store = {};
    const attachUpload = (uploadId)=>{
        if (!uploadId) {
            return;
        }
        const { editorState: newState, blockKey } = attachUploadBlock(store.getEditorState(), uploadId);
        store.setEditorState(newState);
        return blockKey;
    };
    const attachDeviation = (deviation, blockKey)=>{
        const newState = attachDeviationBlock(store.getEditorState(), deviation, blockKey);
        if (newState) {
            store.setEditorState(newState);
        }
    };
    return {
        extras: {
            uploadHelpers: {
                attachUpload,
                attachDeviation
            }
        },
        plugin: (config)=>{
            const type = DND_UPLOAD_TYPE;
            const { helpers, theme, t, [type]: settings = {}, getEditorState, setEditorState } = config, rest = _object_without_properties(config, [
                "helpers",
                "theme",
                "t",
                type,
                "getEditorState",
                "setEditorState"
            ].map(_to_property_key));
            store = {
                getEditorState,
                setEditorState
            };
            return createBasePlugin(_object_spread({
                type,
                settings,
                component: UploadThumb,
                theme,
                t
            }, rest));
        }
    };
}
export { dndUploadPluginCreator };

//# sourceMappingURL=createDndUploadPlugin.js.map